import { DocsExamples } from "@/types/docs-reference";

import primary from "./primary.mml";

export const examples: DocsExamples = {
  primary: {
    title: "Basic m-prompt",
    description: "This is a basic m-prompt.",
    code: primary,
  },
};
